<template>
  <!-- 我的页面 -->
  <div class="myPage">
    <div class="titleBox">{{ $route.meta.title }}</div>
    <div class="homePage">
      <div class="leftBox">
        <div>
          <img class="touxiang" :src="img" alt="" />
        </div>
        <div class="userName">{{ username }}</div>
      </div>

      <div class="middleBox">
        <!-- <div>
          <van-icon name="user-o" /><span class="textContent">租户管理员</span>
        </div>
        <div>
          <van-icon name="phone-o" /><span class="textContent"
            >18099767341</span
          >
        </div> -->
      </div>
    </div>
    <div class="detailPage">
      <div class="menu">
        <div class="menuItem" @click="goMyInfo">
          <div class="menuBox">
            <div class="box">
              <div class="tupian">
                <img class="iconImg" src="../assets/icon/katong1.png" alt="" />
              </div>
              <div class="boxText">个人信息</div>
            </div>
          </div>
          <div class="rightBox">
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="menuItem" @click="loginOut">
          <div class="menuBox">
            <div class="box">
              <div class="tupian">
                <img class="iconImg" src="../assets/icon/katong1.png" alt="" />
              </div>
              <div class="boxText">退出登录</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-popup v-model="showPopup" class="popup" round :style="{ height: '20%', width: '80%' }">
      <div class="popupBox">
        <div class="popupTitle">确定退出登录吗？</div>
        <div class="btnBox">
          <!-- type="info"  -->
          <van-button @click="okLoginOut" round size="large"
            style="background: rgb(72, 113, 192); color: white">确定</van-button>
          <van-button @click="cancelLoginout" type="default" round size="large" style="
                          border: 1px solid rgb(72, 113, 192);
                          color: rgb(72, 113, 192);
                          margin-left: 12px;
                        ">取消</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { loginOutApi } from "@/api/my";
import { userDetailApi } from "@/api/myInfo";
export default {
  name: "My",
  data() {
    return {
      showPopup: false,
      username: "",
      img: "",
    };
  },
  created() {
    this.getUserDetail();
  },
  methods: {
    getUserDetail() {
      userDetailApi().then(
        (res) => {
          this.username = res.data.username;
          this.img = res.data.image;
        }
      );
    },
    loginOut() {
      this.showPopup = true;
    },
    okLoginOut() {
      loginOutApi().then(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("adminID");
        localStorage.removeItem("pgcList");
        this.$router.push({ path: "/login" });
      });
    },
    cancelLoginout() {
      this.showPopup = false;
    },
    goMyInfo() {
      this.$router.push({ path: "/myInfo" });
    },
  },
};
</script>
<style scoped lang="less">
.myPage {
  .titleBox {
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    background: rgb(72, 113, 192);
    justify-content: center;
    color: white;
    font-size: 36px;
  }

  .homePage {
    width: 100%;
    color: white;
    font-size: 28px;
    background: rgb(72, 113, 192);

    .leftBox {
      height: 200px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .touxiang {
        display: block;
        width: 100px;
        height: 100px;
        border-radius: 50%;
      }

      .userName {
        margin-left: 10px;
      }
    }

    .middleBox {
      display: flex;
      height: 120px;
      width: 100%;
      justify-content: space-around;
      align-items: center;
      flex-direction: row;

      div {
        margin-bottom: 30px;

        .textContent {
          margin-left: 20px;
        }
      }
    }

    .rightBox {
      display: flex;
      justify-content: flex-end;
      font-size: 30px;
    }
  }

  .detailPage {
    margin: 0px 20px;

    .menuItem {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #ececec;

      .menuBox {
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        width: 100%;

        .iconRight {
          .iconImg {
            width: 60px;
            height: 60px;
            border-radius: 50%;
          }
        }

        .box {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          height: 120px;
          // background: #ececec;
          color: black;

          .iconImg {
            width: 60px;
            height: 60px;
            border-radius: 50%;
          }

          .boxText {
            margin-left: 30px;
            font-size: 26px;
          }

          .rightIcon {
            margin-right: 10px;
          }
        }
      }
    }
  }

  .popup {
    width: 100%;
    height: 20%;

    .popupBox {
      display: flex;
      flex-direction: column;
      margin-top: 25px;

      .popupTitle {
        text-align: center;
        margin: 20px 0px;
        height: 40px;
        line-height: 40px;
        font-size: 36px;
      }

      .btnBox {
        margin-top: 45px;
        margin-left: 16px;
        margin-right: 16px;
        display: flex;
        justify-content: space-around;
      }
    }
  }
}
</style>
